import { FilterPlot, Plot } from '@abaco/portal-global-state/src/modules/global-state/models/Plot';
import { HTTPClient, propsToDatePaged } from '@abaco/web-common/src/HTTP';
import GlobalStateVuexModule from '../state';

class PagingParams {
    offset = 0;
    count = 25;
}

interface PagedResults<R = unknown>
{
    totalcount: number;
    offset: number;
    records: R[];
    count: number;
}

interface Bbch {
    s_bbch_code: string;
    p_bbch_code: string;
    bbch_code: string;
    gender: string;
    sample_uri: string;
    bbch_description: string;
    fk_bbch_parent_code: string;
}



const DEBOUNCE_TIME = 1000;
const TIME_TO_UPDATE = 1000 * 60 * 5;

export default class TreatmentPlotApi {
    private http: HTTPClient;
    private apiRoot: string;
    private lastUpdate = 0;
    private state: GlobalStateVuexModule;
    private lastIncludeSupplyChain = false;


    constructor(http: HTTPClient, apiRoot: string, state: GlobalStateVuexModule) {
        this.http = http;
        this.apiRoot = apiRoot;
        this.state = state;
    }


    public async loadAllPlots(pkCuaa: number, campaign: number, withWKT: boolean, include_supply_chain: boolean) {
        if (new Date().getTime() - this.lastUpdate < DEBOUNCE_TIME) {
            return;
        }
        const neverLoaded = this.state.plots.length === 0;
        const cacheExpired = new Date().getTime() - this.lastUpdate > TIME_TO_UPDATE;
        const subjectChanged = !neverLoaded && this.state.plots[0].plot_subject_id !== pkCuaa;
        const campaignChanged = !neverLoaded && this.state.plots[0].campaign !== campaign;
        const wktParamChanged = withWKT && withWKT !== withWKT;
        const inlcudeSupplyChainChanged = include_supply_chain !== this.lastIncludeSupplyChain;
        this.lastIncludeSupplyChain = include_supply_chain || false;
        if (neverLoaded || cacheExpired || subjectChanged || campaignChanged || wktParamChanged || inlcudeSupplyChainChanged) {
            this.state.plots = [];
            this.lastUpdate = new Date().getTime();
            let count = 0;
            let res: Plot[] = [];
            let totalcount = 0;

            do {
                const curPage = await this.getPlots(pkCuaa, campaign, withWKT, include_supply_chain, { offset: count, count: 300 })
                count += curPage.count;
                totalcount = curPage.totalcount;
                res = [...res, ...curPage.records];
            } while (count < totalcount)

            this.state.plots = res;
        }
    }


    public async getPlots(pkCuaa: number, campaign: number, withWKT: boolean, include_supply_chain: boolean, paging: PagingParams, filter?: FilterPlot): Promise<PagedResults<Plot>> {
        const resFilter = [];
        if (filter?.council_label) {
            resFilter.push(`^council_label like ${filter.council_label.toUpperCase()}`)
        }
        if (filter?.plot_name) {
            resFilter.push(`^plot_name like ${filter.plot_name.toUpperCase()}`)
        }
        if (filter?.crop_label) {
            resFilter.push(`^crop_label like ${filter.crop_label.toUpperCase()}`)
        }
        if (filter?.crop_code) {
            resFilter.push(`crop_code like ${filter.crop_code.toUpperCase()}`)
        }
        if (filter?.rotation) {
            resFilter.push(`rotation eq ${filter.rotation}`)
        }
        if (filter?.showOnlyBio) {
            resFilter.push(`fg_bio eq 1`)
        }
        if(filter?.fullTextSearch) {
            resFilter.push(`^full_text_search like ${filter.fullTextSearch.toUpperCase()}`)
        }
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/subjects/${pkCuaa}/${campaign}/plots`, {
            params: {
                include_graphic: withWKT,
                include_supply_chain: include_supply_chain,
                offset: paging.offset,
                count: paging.count,
                filter: resFilter.length ? resFilter : undefined,
                //sort: "+plot_name"
            }
        })
        propsToDatePaged(res.data, ["valid_from"])
        return res.data;
    }



}
